import React, { useState } from 'react';
import './LoggedHomePage.css';
import smallLogo from './../assets/logo/fourpusJustIcon.png'
//import largeLogo from './../assets/logo/fourpusJustText.png'


export default function LoggedHomePage() {
  const [isPinned, setIsPinned] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const isExpanded = isPinned || isHovered;

  return (
    <div className="app-container">
      <div
        className={`sidebar ${isExpanded ? 'expanded' : 'collapsed'}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="sidebar-header">
          <div className="logo" style={{ cursor: "pointer" }}>
            <img src={smallLogo} alt="Logo" />
            {isExpanded && <span className="logo-text">Fourpus</span>}
          </div>
          {isExpanded && (
            <div
              className={`pin-toggle ${isPinned ? 'pinned' : ''}`}
              onClick={() => setIsPinned(!isPinned)}
              title="Sabit Bırak"
            >
              <i className="fa fa-thumb-tack" aria-hidden="true"></i>
            </div>
          )}
        </div>

        <div className="menu">
          <div className="menu-item">
            <span role="img" aria-label="home"><i class="fa fa-home" aria-hidden="true"></i></span>
            {isExpanded && <span className="menu-text">Anasayfa</span>}
          </div>
          <div className="menu-item">
            <span role="img" aria-label="dates"><i class="fa fa-calendar" aria-hidden="true"></i></span>
            {isExpanded && <span className="menu-text">Randevular</span>}
          </div>
          <div className="menu-item">
            <span role="img" aria-label="customers"><i class="fa fa-users" aria-hidden="true"></i></span>
            {isExpanded && <span className="menu-text">Müşteriler</span>}
          </div>
          <div className="menu-item">
            <span role="img" aria-label="settings"><i class="fa fa-cog" aria-hidden="true"></i></span>
            {isExpanded && <span style={{ marginLeft: "5px" }} className="menu-text">Ayarlar</span>}
          </div>
        </div>
      </div>

      <div className="main-content">
        <nav className="top-navbar">
          <ul className="nav-items">
            <li className="nav-item">Profil</li>
            <li className="nav-item">Bildirimler</li>
            <li className="nav-item">Ayarlar</li>
          </ul>
        </nav>

        <h1>Ana Sayfa</h1>
        <p>İçerikler burada olacak.</p>
      </div>
    </div>
  );
}
